module.exports = __webpack_public_path__ + "img/timer_pause.9a790e24.svg";